'use strict';

function LoanDetails() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _Routes];

  this._$notification = $('#Notification');
  this._additionalAmount = null;
  this._additionalDate = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  // initPage called by parent controller
  this.initPage = function () {
    this.$node = $(this.node);
    this.$node.find('.progress-details__dial').mogo().create('ThreePartDial', {
      type: 'percent-steps',
      percent: this._liquidLoan.principal.paid_percentage * 100
    });
    this._$upcomingPaymentSection = $('.js--upcoming-payments');

    // Process upcoming payments data
    var payments = this._processUpcomingPayments();
    this._generateUpcomingPaymentSection(payments);
    this._setComputedVariablesForCombinedPayment(payments[payments.length - 1]);

    this._$cancelAdditionalPaymentBtn = $('.js--additional-payment-cancel-cta');
    this._$cancelAdditionalPaymentDialog = $('.js--cancel-additional-payment-dialog');
    this._$cancelSubmitBtn = this._$cancelAdditionalPaymentDialog.find('.js--submit');
    this._setupDialogEventHandler();

    this.presenter.addComputedVariable('final_payment_month', ['money.loans.loans[0].final_payment_date'], function (val) {
      return moment(val).format('MMM');
    });
    this.presenter.addComputedVariable('final_payment_year', ['money.loans.loans[0].final_payment_date'], function (val) {
      return moment(val).format('YYYY');
    });
    this.presenter.addComputedVariable('principal_remaining', ['money.loans.loans[0].principal.amount_remaining'], function (val) {
      return val.toFixed(2);
    });
    this.presenter.addComputedVariable('principal_paid', ['money.loans.loans[0].principal.amount_paid'], function (val) {
      return val.toFixed(2);
    });
    this.presenter.addComputedVariable('amount_borrowed', ['money.loans.loans[0].principal.amount'], function (val) {
      return val.toFixed(2);
    });
    this.presenter.addComputedVariable('loan_number', ['money.loans.loans[0].contract_number'], function (val) {
      return val;
    });
    this.presenter.addComputedVariable('apr_rate', ['money.loans.loans[0].apr'], function (val) {
      return val;
    });
    this.presenter.addComputedVariable('payments_left', ['money.loans.loans[0].number_of_payments_remaining'], function (val) {
      return val;
    });
    this.presenter.addComputedVariable('overall_percentage', ['money.loans.loans[0].principal.paid_percentage'], function (val) {
      var percentage = val * 100;
      var finalValue = percentage >= 1 || percentage < 0.01 ? percentage.toFixed(0) : percentage.toFixed(2);
      return finalValue;
    });

    this.node.removeClass('loans-dashboard--loading');
  };

  this._setupDialogEventHandler = function () {
    var _this = this;

    this._$cancelAdditionalPaymentBtn.on('click', function (e) {
      e.preventDefault();
      if (_this._additionalPayment.hasAction('delete_additional_payment')) {
        _this._$cancelAdditionalPaymentDialog.mogo().show();
      } else {
        _this._deleteNotAllowed();
      }
    });
    this._$cancelAdditionalPaymentDialog.find('.js--close-dialog').on('click', function (e) {
      e.preventDefault();
      _this._$cancelAdditionalPaymentDialog.mogo().hide();
    });
    this._$cancelSubmitBtn.on('click', function () {
      _this._$cancelSubmitBtn.mogo().setLoadState();
      _this._additionalAmount = _this._additionalPayment.amount;
      _this._additionalDate = _this._additionalPayment.date;
      _this.deleteAdditionalPayment(_this._deleteSuccess.bind(_this), _this._deleteFail.bind(_this));
    });
  };

  this._deleteSuccess = function () {
    this._$cancelSubmitBtn.mogo().removeLoadState();
    this._$cancelAdditionalPaymentDialog.mogo().hide();
    this._$notification.mogo().create({
      type: 'success',
      msg: 'Your additional payment of $' + this._additionalAmount + ' scheduled for ' + moment(this._additionalDate).format('ddd, MMM D') + ' was successfully cancelled!'
    });

    this._$upcomingPaymentSection.find('.upcoming-payments__content').empty();
    var payments = this._processUpcomingPayments();
    this._generateUpcomingPaymentSection(payments);
    this._setComputedVariablesForCombinedPayment(payments[payments.length - 1]);
  };

  this._deleteFail = function () {
    this._$cancelSubmitBtn.mogo().removeLoadState();
    this._$cancelAdditionalPaymentDialog.mogo().hide();
    this._$notification.mogo().create({
      type: 'warning',
      msg: 'We were not able to cancel your additional payment due to technical issues. Please try again.',
      notificationDescriber: 'generic'
    });
  };

  this._deleteNotAllowed = function () {
    this._$notification.mogo().create({
      type: 'warning',
      msg: 'Your additional payment has been processed already and can’t be cancelled.',
      notificationDescriber: 'already-processed'
    });
  };

  this._generateUpcomingPaymentSection = function (payments) {
    var _this2 = this;

    var paymentContent = this._$upcomingPaymentSection.find('.upcoming-payments__content');
    var tooltipMsgs = [];

    if (payments.length == 1) {
      // Generate DOM for single payment
      var paymentTypeContent = this._generatePaymentTypeContent(payments[0], 0, tooltipMsgs);
      var paymentsContainer = $('\n        <div class="payments-container">\n          <div class="payment">\n            <div class="payment__date">\n              ' + moment(payments[0].date).format('ddd, MMM D') + '\n            </div>\n            <div class="additional-money-container">\n                <div class="payment__money"></div>\n                ' + (payments[0].type == 'paydown' ? '<a class="additional-payment-cancel js--additional-payment-cancel-cta" data-analytics-id="Money-Navigation-Cancel Payment Shown-Navigation-Component">Cancel</a>' : '') + '\n            </div>\n            <div class="payment__type">\n              ' + paymentTypeContent + '\n            </div>\n          </div>\n        </div>\n      ');
      paymentsContainer.find('.payment__money').mogo().create('FormatMoney', { value: payments[0].amount, animated: false });
      paymentContent.append(paymentsContainer);
    } else {
      // Generate DOM for multiple payments
      var paymentsTimeline = $('<div class="payments-timeline"><div class="payments-timeline__top-circle payments-timeline__circle"></div></div>');
      var paymentsContainer = $('<div class="payments-container"></div>');
      payments.forEach(function (p, i) {
        var content = _this2._generatePaymentTypeContent(p, i, tooltipMsgs);
        var pay = $('\n          <div class="payment">\n            <div class="payment__date">\n              ' + moment(p.date).format('ddd, MMM D') + '\n            </div>\n            <div class="additional-money-container">\n                <div class="payment__money"></div>\n                ' + (p.type == 'paydown' ? '<a class="additional-payment-cancel js--additional-payment-cancel-cta" data-analytics-id="Money-Navigation-Cancel Payment Shown-Navigation-Component">Cancel</a>' : '') + '\n            </div>\n            <div class="payment__type">\n              ' + content + '\n            </div>\n          </div>\n        ');
        pay.find('.payment__money').mogo().create('FormatMoney', { value: p.amount, animated: false });
        paymentsContainer.append(pay);
        if (i != payments.length - 1) {
          paymentsTimeline.append($('<div class="payments-timeline__bar"></div><div class="payments-timeline__circle"></div>'));
          paymentsContainer.append($('<hr class="payment-separator">'));
        }
      });
      paymentContent.append(paymentsTimeline);
      paymentContent.append(paymentsContainer);
    }
    if (payments[payments.length - 1].type == 'combined') {
      this._$upcomingPaymentSection.find('.payment-breakdown').addClass('payment-breakdown--show');
    } else {
      this._$upcomingPaymentSection.find('.payment-breakdown').removeClass('payment-breakdown--show');
    }

    tooltipMsgs.forEach(function (tooltipData, index) {
      paymentContent.append($('<div class="tooltip-message small-12 medium-3">' + tooltipData.message + '</div>').mogo().create('ToolTip', {
        id: 'payments-tooltip-' + tooltipData.type + '-' + index,
        targetElementId: 'payments-message-' + index,
        hover: false,
        context: 'DashboardAccount',
        closeIcon: false
      }));
    });
  };

  this._generatePaymentTypeContent = function (payment, tooltipIndex, tooltipMsgs) {
    var paymentTypeContent = void 0;
    var tooltipData = {
      message: '',
      type: ''
    };
    var msg = 'Your Total payment, including principal, interest and Loan Protection Premium.';
    var msgNolp = 'Your regular payment, including principal and interest.';
    var msgDue = 'Your arrangement on your past due balance.';
    var msgAdd = "This is the scheduled additional payment that you've requested.";
    var msgCmbDue = 'Your Total payment, including principal, interest and Loan Protection Premium plus arrangement on your past due balance.';
    var msgCmbDueNolp = 'Your regular payment, including principal and interest plus arrangement on your past due balance.';
    var msgCmbAdd = "Your total payment, including principal, interest and Loan Protection Premium plus a scheduled additional payment that you've requested.";
    var msgCmbAddNolp = "Your regular payment, including principal and interest plus a scheduled additional payment that you've requested.";
    var freq = payment.frequency.toLowerCase() == 'monthly' ? 'monthly' : 'bi-weekly';
    if (payment.type == 'regular') {
      if (payment.protection_amount) {
        tooltipData.message = msg;
        tooltipData.type = 'regular-lp';
      } else {
        tooltipData.message = msgNolp;
        tooltipData.type = 'regular';
      }
      if (this.getLoanLenderId() === 2) {
        paymentTypeContent = '<span>' + freq.charAt(0).toUpperCase() + freq.slice(1) + ' </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
      } else {
        paymentTypeContent = '<span>Regular ' + freq + ' </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
      }
    } else if (payment.type == 'past_due_arrangement') {
      tooltipData.message = msgDue;
      tooltipData.type = 'pda';
      paymentTypeContent = '<span>Past due arrangement </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
    } else if (payment.type == 'paydown') {
      tooltipData.message = msgAdd;
      tooltipData.type = 'additional';
      paymentTypeContent = '<span>Additional </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
    } else if (payment.type == 'combined') {
      if (payment.additional_type == 'past_due_arrangement') {
        if (payment.protection_amount) {
          tooltipData.message = msgCmbDue;
          tooltipData.type = 'combined-lp-pda';
        } else {
          tooltipData.message = msgCmbDueNolp;
          tooltipData.type = 'combined-pda';
        }
        paymentTypeContent = '<span>Regular ' + freq + ' + past due </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
      } else {
        if (payment.protection_amount) {
          tooltipData.message = msgCmbAdd;
          tooltipData.type = 'combined-lp-additional';
        } else {
          tooltipData.message = msgCmbAddNolp;
          tooltipData.type = 'combined-additional';
        }
        paymentTypeContent = '<span>Regular ' + freq + ' + Additional </span><span id="payments-message-' + tooltipIndex + '" class="icon--info"></span>';
      }
    }
    tooltipMsgs.push(tooltipData);
    return paymentTypeContent;
  };

  this._setComputedVariablesForCombinedPayment = function (payment) {
    if (payment && payment.type === 'combined') {
      this.presenter.addComputedVariable('combined_payment_regular_frequency', ['money.loans.loans[0].payment_frequency'], function (val) {
        if (val) {
          if (val.toLowerCase() === 'monthly') return 'monthly';
          if (val.toLowerCase() === 'biweekly') return 'bi-weekly';
        }
        return '';
      }.bind(null, payment.frequency));
      this.presenter.addComputedVariable('combined_payment_additional_type', ['money.loans.loans[0].additional_payments.loan_additional_payments'], function (val) {
        return val;
      }.bind(null, payment.additional_type));
      this.presenter.addComputedVariable('combined_payment_regular_amount', ['money.loans.loans[0].next_payments'], function (val) {
        return val;
      }.bind(null, payment.regular_amount));
      this.presenter.addComputedVariable('combined_payment_additional_amount', ['money.loans.loans[0].additional_payments.loan_additional_payments'], function (val) {
        return val;
      }.bind(null, payment.additional_amount));
      this.presenter.addComputedVariable('combined_payment_ratio', ['money.loans.loans[0].next_payments', 'money.loans.loans[0].additional_payments.loan_additional_payments'], function (total, val, val2) {
        return [val2 / total, val / total];
      }.bind(null, payment.amount, payment.regular_amount, payment.additional_amount));
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('overall_percentage');
    this.presenter.removeComputedVariable('final_payment_month');
    this.presenter.removeComputedVariable('final_payment_year');
    this.presenter.removeComputedVariable('principal_remaining');
    this.presenter.removeComputedVariable('principal_paid');
    this.presenter.removeComputedVariable('amount_borrowed');
    this.presenter.removeComputedVariable('loan_number');
    this.presenter.removeComputedVariable('apr_rate');
    this.presenter.removeComputedVariable('payments_left');

    this.presenter.removeComputedVariable('combined_payment_regular_frequency');
    this.presenter.removeComputedVariable('combined_payment_regular_amount');
    this.presenter.removeComputedVariable('combined_payment_additional_amount');
    this.presenter.removeComputedVariable('combined_payment_additional_type');
    this.presenter.removeComputedVariable('combined_payment_ratio');

    if (this._$cancelAdditionalPaymentDialog) this._$cancelAdditionalPaymentDialog.mogo().destroy();
    this._super();
  };
}